<template>
  <w-column
    class="work-tabs-picker pa-0"
    :cols="cols"
  >
    <WorkBaseTabs
      ref="workBaseTabs"
      v-model="internalValue"
      v-bind="$props"
      @currentTabObj="$emit('currentTabObj', $event)"
      @currentComponent="(component) => $emit('currentComponent', component)"
      @currentTab="(tab) => $emit('currentTab', tab)"
    >
      <template #tab-text="{ tab }">
        <slot
          name="tab-text"
          :tab="tab"
        />
      </template>

      <template #prepend-tabs>
        <slot name="prepend-tabs" />
      </template>

      <template #icon="{ item }">
        <slot
          name="icon"
          :item="item"
        />
      </template>

      <template #item="{ item }">
        <slot
          name="item"
          :item="item"
        />
      </template>

      <template #append-tabs>
        <slot name="append-tabs" />
      </template>

      <template #append-end>
        <slot name="append-end" />
      </template>
    </WorkBaseTabs>
  </w-column>
</template>

<script>
import WorkBaseTabs from '@/components/base_components/tabs/WorkBaseTabs';
export default {
  name: 'WorkTabsPicker',
  components: { WorkBaseTabs },
  props: {
    ...WorkBaseTabs.props,
    grow: { type: Boolean, default: true },
    centerActive: { type: Boolean, default: true },
    value: { type: Number, default: 0 },
    contentless: { type: Boolean, default: true },
    showArrows: { type: Boolean, default: true },
    // specific
    cols: { type: [Number, String], default: '9' }
  },
  computed: {
    internalValue: {
      set(val) {
        if (val != this.internalValue) {
          this.$emit('input', val);
        }
      },
      get() {
        return this.value;
      }
    }
  },
  methods: {
    changeTabTo(tabId) {
      this.$refs.workBaseTabs.changeTabTo(tabId);
    }
  }
};
</script>

<style lang='scss' scoped>
.work-tabs-picker ::v-deep {
  .work-tabs-picker__tabs-wrapper {
    width: 0;
  }

  .w-tabs__content {
    padding: 0;
  }
}
</style>
